import { render, staticRenderFns } from "./newDetailList.vue?vue&type=template&id=e0967430&scoped=true&"
import script from "./newDetailList.vue?vue&type=script&lang=js&"
export * from "./newDetailList.vue?vue&type=script&lang=js&"
import style0 from "./newDetailList.vue?vue&type=style&index=0&id=e0967430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0967430",
  null
  
)

export default component.exports